<template>
  <div class="vendas-producao-page">
    <PageHeader :title="t('Dashboard de Vendas e Produção')" />

    <section class="kpi-section">
      <div class="section-title">{{ t('Vendas') }}</div>
      <KPIRowVendas />
    </section>

    <section class="kpi-section">
      <div class="section-title">{{ t('Produção') }}</div>
      <KPIRowProducao />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import PageHeader from '../../ui/PageHeader.vue';
import KPIRowVendas from '../dashboard/tabs/vendas-producao/KPIRowVendas.vue';
import KPIRowProducao from '../dashboard/tabs/vendas-producao/KPIRowProducao.vue';

const { t } = useI18n();
</script>

<style scoped>
.vendas-producao-page {
  padding: 20px;
}
.vendas-producao-page :deep(.header-text h1) {
  font-size: 20px;
}
.section-title {
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--p-text-color-secondary);
  margin-bottom: 1rem;
  background-color: var(--p-surface-200);
  padding: 10px;
  border-radius: 8px;
}
.kpi-section {
  background: var(--p-surface-ground);
  border-radius: 8px;
  padding: 1.25rem;
}
</style>
